// component imports
import MapCard from '../maps/MapCard.vue';

// other utility classes
import str from '../common/strings';

// OpenLayers imports
import VectorSource from 'ol/source/vector';
import Cluster from 'ol/source/cluster.js';
import GeoJSON from 'ol/format/geojson';
import Style from 'ol/style/style';

import mapUtils from '../../src/maps/utils';


export default {

    components: { 'map-card': MapCard },

    props: {

        units: {
            type: Array,
            required: true,
        },

        type: {
            type: String,
            required: true,
        },

        searchLength: {
            type: Number,
            default: 2500,
        }

    },

    data() {
        return {

            mapConfig: {
                height: '400px',
                layers: [
                    { create: () => {
                        return this.unitsOlLayer;
                    } },
                    { create: () => {
                        return this.searchUnitsOlLayer;
                    } },
                ],
                featureFilters: [{
                    layer: this.type,
                    filterFcn: this.unitFeatureFilter,
                }],
            },

            filteredItems: [],

            clusteredSource : null,
            unitsOlSource: null,

            currentUrl: window.location.href.replace('#', ''),

        };
    },

    computed: {

        // type with capital first char ('district' => 'District')
        typeCapitalized: function() {
            return str.capitalize(this.type);
        },

        shouldSearchMap: function() {

            if (!this.unitsOlSource) {
                return true;
            }

            return this.unitsOlSource.getFeatures().length < this.searchLength;
        }

    },

    watch: {

        filteredItems: {
            handler: function() {

                if (this.shouldSearchMap === false) {
                    return;
                }

                this.filterFeatures();
            },
            deep: true,
        }

    },

    methods: {

        filterFeatures() {
            if (this.unitsOlSource === null) {
                // features not yet initialized
                return;
            }

            let sourceForSearchLayer = this.searchUnitsOlLayer.getSource();
            sourceForSearchLayer.clear(); // clear existing features inside

            let featureCodes = this.filteredItems.map((item) => {
                return Number.parseInt(item.id);
            });

            // FEATURES TO SPECIAL COLLECTION!
            this.unitsOlSource.forEachFeature((feature) => {
                if (featureCodes.indexOf(Number.parseInt(feature.get('id'))) >= 0) {
                    sourceForSearchLayer.addFeature(feature);
                }
            });
        },

        initBasicMapLayer(geoJsonSource) {
            if (geoJsonSource.features.length === 0) {
                return;
            }

            // generate source from GeojSON for a basic layer
            this.unitsOlSource = new VectorSource({
                features: (new GeoJSON()).readFeatures(geoJsonSource, {
                    dataProjection: 'EPSG:4326',
                    featureProjection: 'EPSG:3857',
                }),
            });

            // add source to layer
            this.unitsOlLayer.setSource(this.unitsOlSource);

            // add name for aech feature in source (will need it for labels)
            this.unitsOlSource.forEachFeature((feature) => {
                feature.set('name', feature.getProperties()['name']);
            });
        },

        initClusteredMapLayer(geoJsonSource) {
            if (geoJsonSource.features.length === 0) {
                return;
            }

            // generate source from GeojSON for a basic layer
            this.unitsOlSource = new VectorSource({
                features: (new GeoJSON()).readFeatures(geoJsonSource, {
                    dataProjection: 'EPSG:4326',
                    featureProjection: 'EPSG:3857',
                }),
            });

            this.clusteredSource = new Cluster({
                distance : 120,
                source : this.unitsOlSource
            });

            // add source to layer
            this.unitsOlLayer.setSource(this.clusteredSource);
            this.unitsOlLayer.setStyle(mapUtils.clusteredStyle);

            // add name for aech feature in source (will need it for labels)
            this.unitsOlSource.forEachFeature((feature) => {
                feature.set('name', feature.getProperties()['name']);
            });

        }

    }

};



// WEBPACK FOOTER //
// ./resources/assets/js/components/mixins/MapAndTable.js